import { useState, useEffect } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from 'src/Admin/img/findcare/FindCareSVG';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import BrokerViewPanel from '../../User/Personas/Brokers/BrokerView';
import ListWithShowMoreLess from '../../common/ListWithShowMoreLess';
import BlobViewListItem from '../../User/BlobEmployerLocation/Blob/BlobViewListItem';
import EmployerViewListItem from '../../User/BlobEmployerLocation/Employer/EmployerViewListItem';
import FacilitiesViewListItem from '../../User/Personas/Providers/Facility/FacilitiesViewListItem';
import DoctorViewPanel from '../../User/Personas/Providers/Doctors/DoctorView';

const Affiliation = () => {
  const { userData } = useSelector((state) => state?.user);
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { Broker_User_Creation_Setting } = Network_Setting;

  const [blobList, setBlobList] = useState([]);

  const [activeId, setActiveId] = useState(null);

  const [blobActiveId, setBlobActiveId] = useState(null);

  const [isSuperUser, setisSuperUser] = useState(false);

  const [showMoreBlobs, setShowMoreBlobs] = useState(false);
  const [showMoreEmployers, setShowMoreEmployers] = useState(false);
  const [showMoreLocations, setShowMoreLocations] = useState(false);
  const [showMoreFacilities, setShowMoreFacilities] = useState(false);
  const [mappedEntities, setMappedEntities] = useState([]);

  let blobs = [];

  useEffect(() => {
    let blobLen = 0;
    if (userData?.SuperUser) {
      setisSuperUser(true);
    }
    if (
      userData?.UserType === 'Client' ||
      (userData?.UserType === 'Broker' &&
        Broker_User_Creation_Setting === false)
    ) {
      const allEmployers = [];
      if (userData?.MappedEnties?.length > 0) {
        userData?.MappedEnties.map((e, index) => {
          e.Client.map((emp) => {
            allEmployers.push({ ...emp, oid: emp.ClientOid });
            return;
          });
          if (index === userData?.MappedEnties.length - 1) {
            setMappedEntities(allEmployers);
          }
          return e;
        });
      } else {
        setMappedEntities([]);
      }
    } else {
      if (userData?.MappedEnties?.length > 0) {
        if (userData?.MappedEnties?.length > 0) {
          blobs = userData?.MappedEnties.map((blob, blobIdx) => {
            blobLen = blobIdx;

            return blob.BlockOfBusinessName;
          });
        }
        setBlobList(blobs);
        setMappedEntities(
          userData?.MappedEnties.map((e) => {
            return {
              ...e,
              BlkOfBusId: e.BlkOfBusOid,
              BlkOfBusName: e.BlockOfBusinessName,
              Client: e.Client.map((c) => {
                return { ...c, oid: c.ClientOid };
              }),
            };
          }),
        );
      } else {
        setMappedEntities([]);
      }
    }
  }, [userData]);

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const toggleBlobActive = (id) => {
    if (blobActiveId === id) {
      setBlobActiveId(null);
    } else {
      setBlobActiveId(id);
    }
  };

  const RenderEmployerListItem = ({ data, index }) => {
    const client = data;
    return (
      <div className="header-border" key={`emp-${index}`}>
        <EmployerViewListItem
          client={client}
          locationProps={{
            selectedLocation: client?.Location,
            locationCount:
              client?.Location?.length > 0
                ? `${client.Location.length} Locations`
                : 'All Locations',
          }}
          showMoreLocations={showMoreLocations}
          setShowMoreLocations={setShowMoreLocations}
        />
      </div>
    );
  };

  const ViewEmployerList = (data) => {
    return (
      <ListWithShowMoreLess
        data={data}
        RenderItemComponent={RenderEmployerListItem}
        showMoreLabel="Employers"
        keyProperty={'ClientOid'}
        showMore={showMoreEmployers}
        setShowMore={setShowMoreEmployers}
      />
    );
  };

  const ViewBlobLists = (data) => {
    return (
      <ListWithShowMoreLess
        data={data}
        RenderItemComponent={RenderBlobListItem}
        showMoreLabel="Blobs"
        keyProperty={'BlkOfBusOid'}
        showMore={showMoreBlobs}
        setShowMore={setShowMoreBlobs}
      />
    );
  };

  const RenderBlobListItem = ({ data, index }) => {
    const blob = data;
    console.log('blob ->', blob);
    return (
      <div className="header-border" key={`blob-${index}`}>
        <BlobViewListItem
          key={blob.BlkOfBusOid}
          blob={blob}
          onClick={() => toggleBlobActive(`blob-${index}`)}
          accordionArrowClass={
            blobActiveId === `blob-${index}` ? 'down-arrow' : ''
          }
          employerProps={{
            employerCount:
              blob?.Client?.length > 0
                ? `${blob?.Client?.length} Employers`
                : 'All Employers', //selectedEmployerCount( blob.oid ),
            selectedEmployer: blob?.Client || [], //createUserFormData.BLOBDetails.selectedEmployers[ blob.oid ] || []
          }}
          locationProps={{
            selectedLocationCount: (clientOid) => {
              const clientIndex = blob.Client.findIndex(
                (e) => e.ClientOid === clientOid,
              );
              if (clientIndex > -1)
                return blob.Client[clientIndex].Location?.length > 0
                  ? `${blob.Client[clientIndex].Location?.length} Locations`
                  : `All Locations`;
              else return 'All Locations';
            }, //selectedLocationCount,
            selectedLocation:
              blob?.Client?.length > 0
                ? blob.Client.reduce((a, v) => {
                    return { ...a, [v.ClientOid]: v.Location };
                  }, {})
                : {},
            //[] //createUserFormData.BLOBDetails.selectedLocations
          }}
          showMoreLocations={showMoreLocations}
          setShowMoreLocations={setShowMoreLocations}
          showMoreEmployers={showMoreEmployers}
          setShowMoreEmployers={setShowMoreEmployers}
        />
      </div>
    );
  };

  const getSelectedFacilities = () => {
    const facilities = [];
    const userProviderAffiliationDetails =
      userData?.UserProviderAffiliationDetails;
    if (
      userProviderAffiliationDetails &&
      userProviderAffiliationDetails.length > 0
    ) {
      userProviderAffiliationDetails.map(
        (u) =>
          u.FacilityDetails &&
          u.FacilityDetails.length > 0 &&
          u.FacilityDetails.map((f) => facilities.push(f)),
      );
    }
    return facilities;
  };

  const getSelectedDoctorsByFacilities = () => {
    let tempObj = {};
    const userProviderAffiliationDetails =
      userData?.UserProviderAffiliationDetails;
    if (
      userProviderAffiliationDetails &&
      userProviderAffiliationDetails.length > 0
    ) {
      userProviderAffiliationDetails.forEach((u) => {
        u.FacilityDetails &&
          u.FacilityDetails.length > 0 &&
          u.FacilityDetails.forEach((f) => {
            const obj = { [u.FacilityOid]: f.PhysicianDetails };
            tempObj = Object.assign({ ...tempObj }, obj);
          });
      });
    }
    return tempObj;
  };

  const getSelectedDoctors = () => {
    const filterDoctors = [];
    const userProviderAffiliationDetails =
      userData?.UserProviderAffiliationDetails;
    if (userProviderAffiliationDetails) {
      userProviderAffiliationDetails.map((doc) => {
        doc.FacilityDetails &&
          doc.FacilityDetails.length > 0 &&
          doc.FacilityDetails.map((d) => {
            d.PhysicianDetails.map((p) => {
              filterDoctors.push(p);
              return;
            });
            return;
          });
        return;
      });
      return filterDoctors;
    }
  };

  const RenderFacilitiesListItem = ({ data, index }) => {
    return (
      <FacilitiesViewListItem
        data={data}
        index={index}
        selectedDoctors={getSelectedDoctorsByFacilities()}
        allowDoctorSelection={false}
        showDoctorTrashIcon={false}
        maskTaxId={true}
      />
    );
  };

  return (
    <div>
      <div className="affiliation-my-profile">
        <Card className="card-container">
          <div className="top-section">
            <div className="user-icon">
              {userData?.FirstName[0] + userData?.LastName[0]}
            </div>
            <div className="name-email-container">
              <div className="name">{`${userData?.FirstName}${
                userData?.MiddleName ? ' ' + userData?.MiddleName + ' ' : ' '
              }${userData?.LastName}`}</div>
              <div className="email">{userData?.UserID || '-'}</div>
            </div>
            <div className="user-type-data-container">
              <div className="heading">User Type</div>
              <div className="data">
                {userData?.UserType
                  ? userData?.UserType === 'Client'
                    ? 'Employer'
                    : userData?.UserType
                  : '-'}
              </div>
            </div>
          </div>
          <div className="affiliation-info-section">
            <div className="heading">Affiliation</div>
            <div className="affiliation-accordion-section">
              <Accordion>
                {userData?.UserType === 'Broker' && (
                  <div className="my-profile-accordion-container">
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() => toggleActive(0)}
                      className="panel-toggle text-left w-100"
                      eventKey="0"
                    >
                      <div className="panel-card-header">
                        <div>
                          <span className="accordion-arrow">
                            {activeId === 0 ? (
                              <AccordionUpArrow className="acc-arrow" />
                            ) : (
                              <AccordionDownArrow className="acc-arrow" />
                            )}
                          </span>
                          <span className="accordion-name">Broker(s)</span>
                        </div>
                        <div className="accordion-header-data-count">
                          {userData?.BrokerDetails?.length > 0
                            ? userData?.BrokerDetails?.length +
                              ` Broker${
                                userData?.BrokerDetails?.length > 1 ? 's' : ''
                              }`
                            : isSuperUser
                            ? ''
                            : '0 Broker'}
                        </div>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body className="p-0">
                        {userData?.BrokerDetails &&
                        userData?.BrokerDetails?.length > 0 ? (
                          <BrokerViewPanel
                            selectedBrokers={userData?.BrokerDetails}
                          />
                        ) : (
                          <CustomClientError
                            ErrorHeading="There are no Brokers assigned to this User."
                            className="permission-err-msg"
                          />
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                )}
                <div className="my-profile-accordion-container">
                  <div className="employer-details-container">
                    {(userData?.UserType === 'Client' ||
                      (userData?.UserType === 'Broker' &&
                        Broker_User_Creation_Setting === false)) && (
                      <>
                        <Accordion.Toggle
                          as={Card.Header}
                          onClick={() => toggleActive(1)}
                          className="panel-toggle text-left w-100"
                          eventKey="1"
                        >
                          <div className="d-flex panel-card-header">
                            <div>
                              <span className="accordion-arrow">
                                {activeId === 1 ? (
                                  <AccordionUpArrow className="acc-arrow" />
                                ) : (
                                  <AccordionDownArrow className="acc-arrow" />
                                )}
                              </span>
                              <span className="accordion-name">
                                Employer(s)
                              </span>
                            </div>
                            <div className="panel-card-link" type="button">
                              {mappedEntities?.length > 0
                                ? mappedEntities?.length
                                : '0'}{' '}
                              Employer(s)
                            </div>
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                          <Card.Body className="p-0">
                            <Accordion>
                              {ViewEmployerList(mappedEntities || [])}
                            </Accordion>
                          </Card.Body>
                        </Accordion.Collapse>
                      </>
                    )}
                  </div>

                  {((userData?.UserType === 'Broker' &&
                    Broker_User_Creation_Setting === true) ||
                    userData?.UserType === 'Insurer') && (
                    <div className="blob-details-container">
                      <>
                        <Accordion.Toggle
                          as={Card.Header}
                          onClick={() => toggleActive(1)}
                          className="panel-toggle text-left w-100"
                          eventKey="1"
                        >
                          <div className="d-flex panel-card-header">
                            <div>
                              <span className="accordion-arrow">
                                {activeId === 1 ? (
                                  <AccordionUpArrow className="acc-arrow" />
                                ) : (
                                  <AccordionDownArrow className="acc-arrow" />
                                )}
                              </span>
                              <span className="accordion-name">
                                Block of Business(es)
                              </span>
                            </div>
                            {!isSuperUser && (
                              <div className="panel-card-link" type="button">
                                {blobList?.length > 0 ? blobList?.length : '0'}{' '}
                                Block of Businesses
                              </div>
                            )}
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                          <Card.Body className="p-0">
                            <Accordion>
                              {!isSuperUser ? (
                                ViewBlobLists(mappedEntities || [])
                              ) : (
                                <GenericMessage
                                  wrapperClasses="mt-4 mb-4"
                                  message="A Super User has access to all Blocks of Business."
                                  messageType={'info'}
                                  showMessage={true}
                                  hideCloseButton={true}
                                />
                              )}
                            </Accordion>
                          </Card.Body>
                        </Accordion.Collapse>
                      </>
                    </div>
                  )}
                </div>
                {userData?.UserType === 'Provider' && (
                  <div className="my-profile-accordion-container">
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() => toggleActive(2)}
                      className="panel-toggle text-left w-100"
                      eventKey="0"
                    >
                      <div className="panel-card-header">
                        <div>
                          <span className="accordion-arrow">
                            {activeId === 2 ? (
                              <AccordionUpArrow className="acc-arrow" />
                            ) : (
                              <AccordionDownArrow className="acc-arrow" />
                            )}
                          </span>
                          <span className="accordion-name">Provider(s)</span>
                        </div>
                        <div className="accordion-header-data-count">
                          {userData?.Is_DoctorFacility
                            ? getSelectedFacilities().length > 0
                              ? getSelectedFacilities().length
                              : '0'
                            : getSelectedDoctors().length > 0
                            ? getSelectedDoctors().length
                            : '0'}{' '}
                          Providers
                        </div>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body className="p-0">
                        {userData?.Is_DoctorFacility && (
                          <Accordion>
                            <ListWithShowMoreLess
                              data={getSelectedFacilities()}
                              RenderItemComponent={RenderFacilitiesListItem}
                              showMore={showMoreFacilities}
                              setShowMore={setShowMoreFacilities}
                              showMoreLabel={'Facilities'}
                            />
                          </Accordion>
                        )}
                        {!userData?.Is_DoctorFacility && (
                          <Accordion>
                            <DoctorViewPanel
                              maskTaxId={true}
                              selectedDoctors={getSelectedDoctors()}
                            />
                          </Accordion>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                )}
              </Accordion>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Affiliation;
